import { defineStore } from "pinia"
import { ref } from "vue"

export interface Banner {
  /**
   * The message to be shown in the banner
   */
  message: string
  /**
   * The type of the banner style
   */
  type: "info",
  /**
   * Possible actions that are displayed as buttons on the banner. The values
   * should be the labels of the buttons. These labels are passed to the action
   * callback to determine which button the user has clicked.
   */
  actions?: string[]
  /**
   * Called when the user clicks a button. Receives the action string.
   *
   * @param   {string}  action  The value from `actions` corresponding to this button
   */
  actionCallback?: (action: string) => void
  /**
   * Called when the banner is dismissed
   */
  onDismiss?: () => void
}

export const useBannerStore = defineStore("banner", () => {
  const banners = ref<Banner[]>([])

  function dismiss (banner: Banner) {
    if (banner.onDismiss !== undefined) {
      banner.onDismiss()
    }

    const idx = banners.value.indexOf(banner)
    if (idx > -1) {
      banners.value.splice(idx, 1)
    }
  }

  function show (banner: Banner) {
    banners.value.push(banner)
  }

  return { banners, dismiss, show }
})
